export default [
  {
    path: '/homeworks',
    name: 'homework',
    meta: { requiresAuth: true },
    component: () => import('@/pages/eschool/homework/index.vue')
  },
  {
    path: '/homeworks/create',
    name: 'homework-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/eschool/homework/create.vue')
  },
  {
    path: '/homeworks/:id/edit',
    name: 'homework-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/eschool/homework/edit.vue')
  },
  {
    path: '/homeworks/comments/:id',
    name: 'homework-comment-public',
    meta: { requiresAuth: true },
    component: () => import('@/pages/eschool/homework/comment/index.vue')
  },
  {
    path: '/homeworks/corrections/:id',
    name: 'homework-correction',
    meta: { requiresAuth: true },
    component: () => import('@/pages/eschool/homework/correction/index.vue')
  }
]
